import React, { useState } from 'react';
import styled from 'styled-components';
import { LFC } from '../../Legacy';
import { defineCommand } from '../../concepts/commands/CommandDefinition';
import { Prompt } from '../../ui';
import { PopupTabs } from '../../ui/PopupTabs';
import { useResolve } from '../Container';
import { AccountModel } from '../account/AccountModel';
import { usePermissions } from '../common/PermissionElements';
import { Flexer } from '../dashboard/elements/LayoutElements';
import { Popup, PopupProps } from '../popups/Popup';
import { PopupManager } from '../popups/PopupManager';
import { AccountEmailInviteView } from './AccountEmailInviteView';
import { AccountLinkInviteView } from './AccountLinkInviteView';

const Toggle = styled.div<{ visible: boolean }>`
    display: ${p => p.visible ? 'block' : 'none'};
`;

export const accountInvitePopup = () => ({ ui: AccountInvitePopup });

export const AccountInvitePopup: LFC<PopupProps> = ({ dismiss }) => {

    const account = useResolve(AccountModel);
    const [canLink] = usePermissions('ac_team:write');
    const [tab, setTab] = useState('email' as 'email' | 'link');

    return <Prompt ignoreEnter onAction={dismiss}>
        <Popup w={40}>
            <Popup.Close onAction={dismiss} />
            <Popup.Title>Invite People To {account.label}</Popup.Title>
            <Popup.Content>
                {canLink && <>
                    <PopupTabs>
                        <PopupTabs.Item onClick={() => setTab('email')} selected={tab === 'email'}>Via Email</PopupTabs.Item>
                        <PopupTabs.Item onClick={() => setTab('link')} selected={tab === 'link'}>Via Link</PopupTabs.Item>
                    </PopupTabs>
                    <Flexer height="1" />
                </>}
                <Toggle visible={tab === 'email'}>
                    <AccountEmailInviteView />
                </Toggle>
                {canLink && <Toggle visible={tab === 'link'}>
                    <AccountLinkInviteView />
                </Toggle>}
            </Popup.Content>
        </Popup>
    </Prompt>;
};

export const accountInvite = defineCommand(
    'accountInvite',
    'Account: Invite...',
    async r => {
        const popups = r.call(PopupManager);
        await popups.invoke({ ui: AccountInvitePopup });
    }
);
